import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import useIsIPhone from "../../hooks/useIsIphone";

// css
import "./InvestmentsStyles.css";

// components
import Gcard from "./InvestmentsGridCard";
import HoldingsSection from "./HoldingsSection";
// import TestChart from "../digital-infrastructure/charts/testChart";
import Group2Card from "./Group2Card";

const PortfolioSummary = () => {
  const slider = React.useRef(null);
  const isIphone = useIsIPhone();
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_metrics.json`;

  // settings for the react slider
  const settings = {
    dots: true,
    className: "center",
    centerMode: true,
    infinite: true,
    // centerPadding: "60px",
    speed: 500,
    slidesToShow: 1,
    // slidesToScroll: 1,
    arrows: false,
  };

  // states
  const [asOfDate, setAsOfDate] = useState("");
  const [data, setData] = useState([]);
  const [group1, setGroup1] = useState([]);
  const [group2, setGroup2] = useState([]);
  // const [group3, setGroup3] = useState([]);
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });
  // const [group3, setGroup3] = useState([]);

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    // let asOfDatePull = data.product.highlight[0];
    // setAsOfDate(asOfDatePull.value);
    // setData(data.product.highlight);

    // console.log(data.product.metric);
    // console.log(data);

    // ✅ Normalize metrics
    const metrics = Array.isArray(data.product.metric)
      ? data.product.metric
      : [data.product.metric];

    // GROUP-1
    metrics
      .filter((typeKey) => typeKey["@type_key"] === "GROUP-1")
      .forEach((filteredKey) => {
        setGroup1(filteredKey);
      });

    // GROUP-2
    metrics
      .filter((tKey) => tKey["@type_key"] === "GROUP-2")
      .forEach((fKey) => {
        group2.push(fKey);
        // setGroup2(fKey)
      });

    // GROUP-3 (optional: uncomment if needed)
    // metrics
    //   .filter((typeKey) => typeKey["@type_key"] === "GROUP-3")
    //   .forEach((filteredKey) => {
    //     setGroup3(filteredKey);
    //   });
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  function renderMetricItems() {
    const arrayInfo = Array.isArray(group1.values)
      ? group1.values
      : [group1.values];

    return arrayInfo.map((items) => {
      const sortOrder = items["@sort_order"];
      return (
        <Gcard
          key={sortOrder}
          top={items.value}
          bottom={items.name}
          footnote={items.footnote_key}
        />
      );
    });
  }

  function renderGroup2Cards(displayType) {
    let g2MappedArray = Array.isArray(group2) ? (
      group2.map((item) => {
        return (
          <Group2Card
            key={item["@sort_order"]}
            dType={displayType}
            title={item.name}
            titleSup={item.footnote_key}
            imgPath={item.metric_image}
            i1Name={item.values[0]["name"]}
            i1Value={item.values[0]["value"]}
            i1Sup={item.values[0]["footnote_key"]}
            i2Name={item.values[1]["name"]}
            i2Value={item.values[1]["value"]}
            i2Sup={item.values[1]["footnote_key"]}
            i3Name={item.values[2]["name"]}
            i3Value={item.values[2]["value"]}
            i3Sup={item.values[2]["footnote_key"]}
            i4Name={item.values[3]["name"]}
            i4Value={item.values[3]["value"]}
            i4Sup={item.values[3]["footnote_key"]}
            i5Name={item.values[4]["name"]}
            i5Value={item.values[4]["value"]}
            i5Sup={item.values[4]["footnote_key"]}
            i6Name={item.values[5]["name"]}
            i6Value={item.values[5]["value"]}
            i6Sup={item.values[5]["footnote_key"]}
          />
        );
      })
    ) : (
      <Group2Card
        key={group2["@sort_order"]}
        dType={displayType}
        title={group2.name}
        titleSup={group2.footnote_key}
        imgPath={group2.metric_image}
        i1Name={group2.values[0]["name"]}
        i1Value={group2.values[0]["value"]}
        i1Sup={group2.values[0]["footnote_key"]}
        i2Name={group2.values[1]["name"]}
        i2Value={group2.values[1]["value"]}
        i2Sup={group2.values[1]["footnote_key"]}
        i3Name={group2.values[2]["name"]}
        i3Value={group2.values[2]["value"]}
        i3Sup={group2.values[2]["footnote_key"]}
        i4Name={group2.values[3]["name"]}
        i4Value={group2.values[3]["value"]}
        i4Sup={group2.values[3]["footnote_key"]}
        i5Name={group2.values[4]["name"]}
        i5Value={group2.values[4]["value"]}
        i5Sup={group2.values[4]["footnote_key"]}
        i6Name={group2.values[5]["name"]}
        i6Value={group2.values[5]["value"]}
        i6Sup={group2.values[5]["footnote_key"]}
      />
    );
    return g2MappedArray;
  }

  return (
    <section className="portfolio-summary-container" id="portfolio-summary">
      <div className="">
        <div className="main-margin">
          <div className="">
            <div className="ps-left text-center pt-5 lg:pt-10 px-[30px] xl:px-0">
              <h1 className="sub-header m-t-0" style={{ marginBottom: "7px" }}>
                {group1.name}
              </h1>
              <p>{group1.description}</p>
            </div>
            <div>
              <div className="value-grid px-[30px] xl:px-0">
                {renderMetricItems()}
              </div>
              {screenSize.dynamicWidth > 888 || isIphone ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-16 px-[30px] xl:px-0">
                  {renderGroup2Cards("desktop")}
                </div>
              ) : (
                <Slider ref={slider} {...settings}>
                  {renderGroup2Cards("mobile")}
                </Slider>
              )}
              <HoldingsSection />
              {/* <TestChart /> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSummary;
